import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { FormValidatorService } from '../../../../../shared/services/form-validator.service';
import { Validators } from '../../../../../shared/validators';
import { CustomValidators } from '../../../../../shared/custom-validators';
import { ACTIVATION_STEPS } from '../../../../../shared/activationSteps';
import { AuthService } from '../../../../../shared/services/auth.service';
import { ActivationStepsService } from '../../../../../shared/services/activation-steps.service';
import { ChangePasswordComponent } from '../../../../../shared/components/change-password/change-password.component';
import { UpdateActivationStatusService } from '../../../../../shared/services/update-activation-status.service';
import { SendVerifyEmailService } from '../../../../../shared/services/send-verify-email.service';
import { PhoneVerifyComponent } from '../../../../../shared/components/phone-verify/phone-verify.component';
import { UpdateUserInfoService } from '../../../../../shared/components/change-password/update-user-info.service';
import { FetchBasicUserInfoService } from '../../services/fetch-basic-user-info.service';
import { LanguageService } from '../../../../../shared/services/language.service';

@Component({
  selector: 'app-personal',
  templateUrl: './personal.component.html',
  styleUrls: ['./personal.component.scss']
})
export class PersonalComponent implements OnInit, OnDestroy {
  basicInfoForm!: FormGroup;
  formValidator: FormValidatorService = new FormValidatorService();
  emailVerified: boolean = false;
  phoneVerified: boolean = false;
  passwordHide: boolean = true;
  passwordConfirmHide: boolean = true;
  phoneVerifyClicked: boolean = false;
  passwordChangeDIalogRef: any;
  initialEmail: string = '';
  num!: string;
  confirmationResult: any;
  windowRef: any;
  subscription!: Subscription;
  hasUpdateBusinessPermission:boolean;
  isBranchBusiness: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ChangePasswordComponent>,
    private fetchInfo: FetchBasicUserInfoService,
    private updateUser: UpdateUserInfoService,
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
    private verifyMail: SendVerifyEmailService,
    public authService: AuthService,
    public UpdateActivationStatus: UpdateActivationStatusService,
    public ActivationSteps: ActivationStepsService,
    private translate: TranslateService,
    private languageService: LanguageService,
    private authServ:AuthService
  ) { }

  async ngOnInit() {
    this.hasUpdateBusinessPermission = await this.authServ.hasPermissionAction("seller.updateBusiness");
    this.isBranchBusiness = (await this.authServ.getBusiness())?.branch || false;
    this.translate.use(localStorage.getItem('language'));
    this.languageService.languageUpdated.subscribe((lang) => {
      this.translate.use(lang);
    })
    this.basicInfoForm = this.formValidator.createForm([
      {
        fieldName: 'first_name',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: ''
          },
          {
            validatorFn: CustomValidators.customPattern(/(^[a-z ]+$)/i),
            message: ''
          },
          {
            validatorFn: CustomValidators.customPattern(/^\S*$/),
            message: ''
          },
          {
            validatorFn: Validators.minLength(2),
            message: ''
          },
          {
            validatorFn: Validators.maxLength(20),
            message: ''
          },
        ]
      },
      {
        fieldName: 'last_name',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: ''
          },
          {
            validatorFn: CustomValidators.customPattern(/^\S*$/),
            message: ''
          },
          {
            validatorFn: Validators.maxLength(20),
            message: ''
          },
          {
            validatorFn: CustomValidators.customPattern(/(^[a-z ]+$)/i),
            message: ''
          },
          {
            validatorFn: Validators.minLength(2),
            message: ''
          }
        ]
      },
      {
        fieldName: 'email',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: ''
          },
          {
            validatorFn: Validators.email,
            message: ''
          }
        ]
      },
      {
        fieldName: 'phone',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: ''
          },
          {
            validatorFn: CustomValidators.customPattern(/(^[0-9\+]{3,}$)/),
            message: ''
          }
        ]
      },
    ]);
    await this.displayInfo();
  }

  ngAfterViewInit() {
    this.translateValidationMessages();
    this.translate.onLangChange.subscribe(() => {
      this.translateValidationMessages();
    })
  }

  translateValidationMessages() {
    this.translate.get('FormValidation').subscribe(() => {
      this.formValidator.validationMessages = {
        "first_name": {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'First name',
            fieldAr: 'الإسم الأول'
          }),
          customPattern: this.translate.instant('FormValidation.TextOnly', {
            field: 'First name',
            fieldAr: 'الإسم الأول'
          }),
          minLength: this.translate.instant('FormValidation.MinLength', {
            field: 'First name',
            fieldAr: 'الإسم الأول',
            value: 2
          }),
          maxLength: this.translate.instant('FormValidation.MaxLength', {
            field: 'First name',
            fieldAr: 'الإسم الأول',
            value: 20
          }),
        },
        'last_name': {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Last name',
            fieldAr: 'الإسم الاخير'
          }),
          customPattern: this.translate.instant('FormValidation.TextOnly', {
            field: 'Last name',
            fieldAr: 'الإسم الاخير'
          }),
          minLength: this.translate.instant('FormValidation.MinLength', {
            field: 'Last name',
            fieldAr: 'الإسم الاخير',
            value: 2
          }),
          maxLength: this.translate.instant('FormValidation.MaxLength', {
            field: 'Last name',
            fieldAr: 'الإسم الاخير',
            value: 20
          }),
        },
        "email": {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Email',
            fieldAr: 'البريد الإلكتروني'
          }),
          email: this.translate.instant('FormValidation.ValidEmail'),
        },
        "phone": {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Phone Number',
            fieldAr: 'رقم هاتف'
          }),
          requiredNumber: this.translate.instant('FormValidation.RequiredNumber'),
        },
      }
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private async displayInfo() {
    const result = await this.fetchInfo.make();
    this.num = result.phone;
    if (this.initialEmail && this.initialEmail != result.email) {
      this.authService.logout();
    }
    this.basicInfoForm.controls['first_name'].setValue(result.first_name);
    this.basicInfoForm.controls['last_name'].setValue(result.last_name);
    this.basicInfoForm.controls['email'].setValue(result.email);
    this.basicInfoForm.controls['phone'].setValue(result.phone);
    this.emailVerified = result.mail_verified;
    this.phoneVerified = result.phone_verified;
    if (this.phoneVerified && this.emailVerified) {
      let params = {
        activationStep: ACTIVATION_STEPS.PHONE_EMAIL_VERIFICATION,
        activationStatus: true
      };
      this.UpdateActivationStatus.setParams(params);
      let result = await this.UpdateActivationStatus.make();
      if (result.success) {
        this.ActivationSteps.setPhoneAndEmailVerifyStep = params;
      }
    }
    this.initialEmail = result.email;
    if (result.mail_verified){
      this.basicInfoForm.controls['email'].disable();
    }



    if (result.phone_verified){
      this.basicInfoForm.controls['phone'].disable();
    }


  }

  async OnFormSubmit() {
    try {
     const formValue = {
        ...this.basicInfoForm.value,
        email: this.basicInfoForm.controls.email.value,
        phone: this.basicInfoForm.controls.phone.value
      }
      this.updateUser.setParams(formValue);
      await this.updateUser.make();
      this.snackBar.open(this.translate.instant('Sellers.Products.UpdatedSuccessfully'), '', { duration: 3000 });
      await this.displayInfo();
    } catch (err) {
      let error = err.faultyRequest.error;
      this.formValidator.formErrors[error.error.field] = error.error.message;
      console.log(err);
    }
  }

  async VerifyPhone() {
    try {
      this.updateUser.setParams({
        ...this.basicInfoForm.value, email: this.basicInfoForm.controls['email'].value,
        phone: this.basicInfoForm.controls['phone'].value
      });
      await this.updateUser.make();
      this.phoneVerifyClicked = true;
      const dialogRef = this.dialog.open(PhoneVerifyComponent, {
        height: '250px',
        width: '400px',
        data: {
          confResult: this.num,
        }
      });

      this.subscription = dialogRef.afterClosed().subscribe(() => {
        this.displayInfo();
      });
    } catch (err) {
      let error = err.faultyRequest.error;
      this.formValidator.formErrors[error.error.field] = error.error.message;
      console.log(err);
    }
  }

  async verify_email() {
    try {
      this.updateUser.setParams({
        ...this.basicInfoForm.value, email: this.basicInfoForm.controls['email'].value,
        phone: this.basicInfoForm.controls['phone'].value
      });
      await this.updateUser.make();
      await this.verifyMail.make();
      this.snackBar.open(this.translate.instant('Sellers.Products.VerificationEmail'), '',
        { duration: 3000 });
      await this.displayInfo();
    } catch (err) {
      let error = err.faultyRequest.error;
      this.formValidator.formErrors[error.error.field] = error.error.message;
      console.log(err);
    }
  }

  async sendSMS() {
    this.VerifyPhone()
  }
}
